export default class FilterProductTemplate {
  productId: number;

  description: string;

  constructor(obj: any = {}) {
    this.productId = obj.productId || null;
    this.description = obj.description || null;
  }

  public static of(obj: any = {}): FilterProductTemplate {
    return new FilterProductTemplate(obj);
  }
}
